import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large VerificationEnable",
    title: `Включение верификации для компании ${_ctx.company.name}`,
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.enableVerification
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        placeholder: "Тип верификации",
        value: _ctx.state.type_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.type_id) = $event)),
        "is-invalid": _ctx.state_form$.type_id.$error,
        "validation-errors": _ctx.state_form$.type_id.$errors,
        options: _ctx.verification_types.list,
        loading: _ctx.verification_types.is_loading,
        failed: _ctx.verification_types.is_failed,
        searchable: false,
        "can-deselect": "",
        onRefresh: _ctx.loadVerificationTypes
      }, null, 8, ["value", "is-invalid", "validation-errors", "options", "loading", "failed", "onRefresh"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onCancel", "onConfirm"]))
}